import cn from 'clsx';
import { LazyImage, useUITheme } from '@crehana/compass.ui';
import { PlayroomRewardIndicatorWithRive } from "../../../PlayroomRewardIndicatorWithRive";
import { usePlayroomRewardsTranslations } from "../../hooks";
import CustomButton from "./components/CustomButton";
import RemainingStockTag from "./components/RemainingStockTag";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var PlayroomRewardCard = function PlayroomRewardCard(_ref) {
  var title = _ref.title,
    description = _ref.description,
    coins = _ref.coins,
    imageSrc = _ref.imageSrc,
    className = _ref.className,
    _ref$stock = _ref.stock,
    stock = _ref$stock === void 0 ? 0 : _ref$stock,
    disabled = _ref.disabled,
    dataTestid = _ref['data-testid'],
    onExchange = _ref.onExchange;
  var _usePlayroomRewardsTr = usePlayroomRewardsTranslations(),
    t = _usePlayroomRewardsTr.t;
  var _useUITheme = useUITheme(),
    isDark = _useUITheme.isDark;
  var shouldRenderRemainingStock = stock > 0 && stock <= 10;
  return /*#__PURE__*/_jsxs("article", {
    "data-testid": dataTestid,
    className: cn(
    // Grid
    'tw-grid tw-gap-0 tw-grid-cols-1 sm:tw-grid-cols-2',
    // Shadow
    !disabled && 'tw-transition-shadow tw-shadow-none dark:tw-shadow-none hover:tw-shadow-03',
    // Others
    'tw-rounded-1.2 dark:tw-text-primary-light-100 tw-z-0', className),
    children: [/*#__PURE__*/_jsxs("div", {
      className: "tw-relative tw-pt-1.2 tw-px-1.2 sm:tw-py-1.2 sm:tw-pr-0 tw-w-full md:tw-h-20",
      children: [shouldRenderRemainingStock && /*#__PURE__*/_jsx(RemainingStockTag, {
        stockCount: stock,
        className: cn('tw-z-1', disabled && 'tw-grayscale')
      }), /*#__PURE__*/_jsx(LazyImage, {
        src: imageSrc || '',
        alt: title,
        isDark: isDark,
        imgClassName: "tw-object-cover tw-w-full tw-h-full",
        className: cn('tw-w-full tw-h-16 sm:tw-h-full tw-overflow-hidden tw-rounded-1.2', disabled && 'tw-grayscale')
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: "tw-flex tw-flex-col tw-justify-between tw-p-2",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "tw-flex tw-flex-col tw-items-start tw-mb-1.6 sm:tw-mb-0 dark:tw-text-neutral-light-100",
        children: [/*#__PURE__*/_jsx("h3", {
          className: "tw-font-subtitle3 tw-mb-0.4",
          children: title
        }), /*#__PURE__*/_jsx("p", {
          className: "tw-font-body4 tw-mb-1.2 tw-line-clamp-2",
          children: description
        }), /*#__PURE__*/_jsx(PlayroomRewardIndicatorWithRive, {
          coins: coins,
          isStaticAnimation: true,
          className: "tw-grow-0",
          animated: false
        })]
      }), /*#__PURE__*/_jsx(CustomButton, {
        onClick: onExchange,
        children: t('PRS_CTA_SEE_DETAIL')
      })]
    })]
  });
};
export default PlayroomRewardCard;